import React from 'react';

const SpeakerMuted = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.313 15.02a.496.496 0 0 0 .708 0 .5.5 0 0 0 0-.707L5.686 4.978l-.052-.051L1.687.98a.5.5 0 0 0-.707.707l3.416 3.416a9 9 0 0 1-.67.016h-.058l-.238-.002c-.729-.01-1.727-.024-2.286.83-.31.47-.31 1.032-.31 2.053s0 1.585.308 2.05c.56.858 1.558.844 2.287.834h.082l.156-.002c.945 0 1.246.126 1.896.788 1.343 1.37 2.128 2.172 2.889 2.172l.002-.002q.226 0 .456-.098c.766-.323.898-1.415.921-3.202zM8.836 9.544l-3.61-3.61c-.425.181-.904.186-1.471.186h-.086l-.25-.003h-.002c-.71-.01-1.195.011-1.436.38-.146.22-.146.676-.146 1.503 0 .828 0 1.283.144 1.5.244.372.728.393 1.438.383l.252-.003c1.212 0 1.773.234 2.61 1.088l.002.002c1.04 1.062 1.94 1.979 2.239 1.851.008-.006.168-.135.251-.976.06-.609.065-1.394.065-2.3"
      fill="#7E7572"
    />
    <path
      d="M11.715 9.81q.075.024.152.024a.5.5 0 0 0 .476-.349q.156-.491.157-1.006c0-.772-.27-1.508-.78-2.13a.5.5 0 1 0-.773.635c.362.44.553.957.553 1.495q0 .358-.11.702a.5.5 0 0 0 .325.629m2.011 1.59a.5.5 0 0 1-.39-.813c.543-.679.83-1.457.83-2.253 0-.968-.41-1.882-1.184-2.644a.5.5 0 0 1 .702-.713c.956.94 1.483 2.133 1.483 3.357 0 1.025-.364 2.02-1.05 2.878a.5.5 0 0 1-.391.187M8.833 6.334a.5.5 0 0 0 .5.5h.001a.5.5 0 0 0 .5-.5v-.191c0-2.26 0-3.504-.905-3.886-.863-.365-1.598.37-2.616 1.39a.5.5 0 1 0 .708.707c.538-.54 1.276-1.278 1.518-1.175.015.007.148.079.224.668.07.545.07 1.318.07 2.296z"
      fill="#7E7572"
    />
  </svg>
);

export default SpeakerMuted;
